import React from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import ActionButton from "../component/Common/ActionButton";

const AccessDenied = () => {
  const history = useHistory();
  const rolesdata = useSelector((state) => state.GetAllRole);

  return (
    <div style={{ display: "flex", height: "90vh", width: "100%" }}>
      {/* <div
        style={{
          width: "210px",
          backgroundColor: "#5CD1D0",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "10px 0",
        }}
      ></div> */}
      {rolesdata?.data?.UserRoles && (
        <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
          {/* <div
          style={{
            height: "60px",
            padding: "10px 20px",
            borderBottom: "1px solid #dee2e6",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background: "#fff",
          }}
        >
          <div
            style={{
              width: "120px",
              height: "20px",
              background: "#e0e0e0",
              borderRadius: "4px",
            }}
          />

          <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
            <div
              style={{
                width: "40px",
                height: "40px",
                background: "#e0e0e0",
                borderRadius: "50%",
              }}
            />
          </div>
        </div> */}

          <div
            style={{
              flex: 1,
              // marginLeft: "15px",
              // marginTop: "15px",
              // backgroundColor: "#ffffff",
              borderRadius: "10px",
            }}
          >
            <div
              style={{
                height: "90%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                padding: "20px",
              }}
            >
              <img
                src="/access.png"
                alt="Access Denied"
                style={{ width: "100px", marginBottom: "20px" }}
              />

              <h3 style={{ color: "#dc3545", fontWeight: "bold" }}>Access Denied</h3>

              <p style={{ fontSize: "16px", marginBottom: "20px" }}>
                You do not have permission to view this page. Contact your admin for access.
              </p>

              <ActionButton text="Go Back" onClick={() => history.goBack()} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AccessDenied;
